// Specimen material options and the field-visibility rules derived from them.
// Single source of truth shared by SpecimenRow, SpecimenPreviewRow, and SpecimenEditForm.

export interface MaterialOption {
  value: string;
  label: string;
}

export const MATERIAL_OPTIONS: MaterialOption[] = [
  { value: "formalin_jar", label: "Formalin jar" },
  { value: "block", label: "Block" },
  { value: "slides_only", label: "Slides only" },
  { value: "blocks_and_slides", label: "Blocks and slides" },
  { value: "blood_tube", label: "Blood tube" },
  { value: "urine_sample", label: "Urine sample" },
  { value: "stool_collection", label: "Stool collection" },
];

/** Material types where a gross description should be shown (specimen already processed). */
export const GROSS_DESCRIPTION_MATERIALS = new Set<string>([
  "block",
  "slides_only",
  "blocks_and_slides",
]);

/** Material values offered when the case is a consultation (already-processed only). */
export const CONSULTATION_MATERIAL_VALUES = new Set<string>([
  "slides_only",
  "blocks_and_slides",
]);

/** Human-readable label for a material value, falling back to the raw value. */
export function getMaterialLabel(value: string | null | undefined): string {
  if (!value) return "";
  return MATERIAL_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
